import $api from "../http";

export default class ReceiptService {
    // Получить все приемки пользователя
    static async getUserReceipts() {
        return $api.get(`/receipts`);
    }

    // Создать новую приемку
    static async createReceipt(receiptData) {
        return $api.post('/receipts', receiptData);
    }

    // Получить приемку по ID
    static async getReceiptById(id) {
        return $api.get(`/receipts/${id}`);
    }

    // Обновить приемку
    static async updateReceipt(id, receiptData) {
        return $api.patch(`/receipts/${id}`, receiptData);
    }

  
    // Удалить приемку
    static async deleteReceipt(id) {
        return $api.delete(`/receipts/${id}`);
    }

    // Добавить товар в приемку
    static async addItemToReceipt(receiptId, itemData) {
        return $api.post(`/receipts/${receiptId}/items`, itemData);
    }

    // Обновить товар в приемке
    static async updateReceiptItem(receiptId, itemId, itemData) {
        return $api.patch(`/receipts/${receiptId}/items/${itemId}`, itemData);
    }

    // Удалить товар из приемки
    static async removeItemFromReceipt(receiptId, itemId) {
        return $api.delete(`/receipts/${receiptId}/items/${itemId}`);
    }

    // Поиск товара по штрихкоду
    static async findProductByBarcode(barcode) {
        return $api.get(`/receipts/products/by-barcode/${barcode}`);
    }

    // Поиск контрагентов
    static async searchCounterparties(query) {
        return $api.get(`/receipts/counterparties/search`, {
            params: { query }
        });
    }

    // Поиск складов
    static async searchStores(query) {
        return $api.get(`/receipts/stores/search`, {
            params: { query }
        });
    }

    // === НОВЫЕ МЕТОДЫ ДЛЯ РАБОТЫ С ЗАКАЗАМИ ПОСТАВЩИКОВ ===

    // Поиск товара в заказах поставщиков по штрихкоду
    static async findProductInPurchaseOrders(barcode) {
        return $api.get(`/receipts/purchase-orders/by-barcode/${barcode}`);
    }

    // Получение информации о заказе поставщика
    static async getPurchaseOrderInfo(purchaseOrderId) {
        return $api.get(`/receipts/purchase-orders/${purchaseOrderId}`);
    }

    // Разделение приемки по заказам и отправка в МойСклад
    static async splitAndSendReceipt(receiptId) {
        return $api.post(`/receipts/${receiptId}/split-and-send`);
    }

    // Отправка конкретной группы в МойСклад
    static async sendSpecificGroup(receiptId, purchaseOrderId) {
        return $api.post(`/receipts/${receiptId}/send-group`, { purchaseOrderId });
    }
}